// src/components/ResponsiveContainer.js
import React from 'react';

/**
 * ResponsiveContainer - Adaptive layout wrapper that replaces PhoneFrame
 *
 * Behavior:
 * - Mobile (< 768px): Full width, full height
 * - Tablet (768px - 1023px): Full width with padding
 * - Desktop (≥ 1024px): Centered container with max-width
 */
const ResponsiveContainer = ({ children }) => {
  return (
    <div className="min-h-screen bg-app-bg-light dark:bg-app-bg text-app-text-light dark:text-app-text">
      {/* Mobile: full width, no max-width */}
      {/* Tablet & Desktop: centered with appropriate max-width */}
      <div className="w-full h-screen lg:h-auto lg:min-h-screen mx-auto lg:max-w-7xl">
        {children}
      </div>
    </div>
  );
};

export default ResponsiveContainer;
